module.exports = __webpack_public_path__ + "static/img/surveyMethod.8d33561.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audits/surveyMethod.png
// module id = 1648
// module chunks = 0